// extracted by mini-css-extract-plugin
export default {"box":"AmfMpyV23hXJNbnlysKg9g=="};